import RecallOptions from './RecallOptions';
import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';
import { injectIntl } from 'react-intl';

// Actions
import { goTo } from 'store/reducers/navigation/actions';

// Selectors
import { getRecallServices } from 'store/reducers/recall/selectors';
import { getAppFlow } from 'store/reducers/userInteractions/selectors';
import { getMileage } from 'store/reducers/appointment/selectors';
import {
  policies,
  getMakeConfig
} from 'store/reducers/dealerSettings/selectors';

const mapStateToProps = state => {
  return {
    currentMileage: getMileage(state),
    configMake: getMakeConfig(state),
    recallServices: getRecallServices(state),
    appFlow: getAppFlow(state),
    policies: policies(state)
  };
};

const mapDispatchToProps = dispatch => bindActionCreators({ goTo }, dispatch);

export default compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(RecallOptions);



// WEBPACK FOOTER //
// ./src/components/molecules/RecallOptions/RecallOptionsContainer.js